import './index.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import { enableMapSet } from 'immer';
import mixpanel from 'mixpanel-browser';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { pdfjs } from 'react-pdf';

import { App } from './App';
import { checkHasRequiredClaims, ClaimsWithPermissions } from './features/auth';

// react-pdf setup
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
enableMapSet();
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <KindeProvider
        clientId={import.meta.env.VITE_AUTH_CLIENT_ID}
        domain={import.meta.env.VITE_AUTH_ENDPOINT}
        redirectUri={import.meta.env.VITE_AUTH_REDIRECT_URI}
        logoutUri={import.meta.env.VITE_LOGOUT_REDIRECT_URI}
        callbacks={{
          onSuccess: async (user, state, context) => {
            const claims: ClaimsWithPermissions | null = await context.getClaims();
            if (!checkHasRequiredClaims(claims)) {
              setTimeout(context.login, 2500);
            }

            if (claims != null) {
              const profileId = claims['user_properties']?.profile_id?.v;
              if (profileId) {
                try {
                  mixpanel.identify(profileId);
                } catch (error) {
                  console.error(error);
                }
              }
            }
          },
        }}
      >
        <App />
      </KindeProvider>
    </StrictMode>
  );
}
